/**
 * TODO STE-1606: replace this placeholder header with proper JSDoc and a Storybook story
 * WIP
 */
import React from "react";

import { css } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";

export type SvgDataListTooltipProps = {
  children: React.ReactNode[];
};

export const SvgDataListTooltip: React.FC<SvgDataListTooltipProps> = ({ children }) => {
  const styles = useStyles(makeStyles);

  return <div className={styles.container}>{children}</div>;
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(4)};
    padding: ${theme.spacing(0, 8)};

    > * {
      padding: 0;
    }
    > *:not(:last-child) {
      padding-bottom: ${theme.spacing(4)};
      border-bottom: 1px solid ${theme.palette.divider};
    }
  `,
});
